import { safeGet } from "./types";

export type CvOnePageFeedback = {
  enabled: boolean;
  titleKey: string;
  bodyKey: string;
};

/**
 * Converts the agent's one-page mutation receipt into user-facing state.
 * Older API responses did not include onePageStatus, so keep a structural
 * fallback for messages restored from persisted chat history.
 */
export function resolveCvOnePageFeedback(
  result: unknown,
  args: unknown,
): CvOnePageFeedback {
  const status = safeGet<string>(result, "onePageStatus");
  const enabled =
    safeGet<boolean>(result, "fitToOnePage") ??
    safeGet<boolean>(result, "sections", "cvConfig", "fitToOnePage") ??
    safeGet<boolean>(args, "enabled") ??
    true;

  if (status === "already_enabled") {
    return {
      enabled: true,
      titleKey: "chat.cvOnePage.alreadyEnabledTitle",
      bodyKey: "chat.cvOnePage.alreadyEnabledBody",
    };
  }

  if (status === "disabled" || status === "already_disabled" || !enabled) {
    return {
      enabled: false,
      titleKey:
        status === "already_disabled"
          ? "chat.cvOnePage.alreadyDisabledTitle"
          : "chat.cvOnePage.disabledTitle",
      bodyKey:
        status === "already_disabled"
          ? "chat.cvOnePage.alreadyDisabledBody"
          : "chat.cvOnePage.disabledBody",
    };
  }

  return {
    enabled: true,
    titleKey: "chat.cvOnePage.enabledTitle",
    bodyKey: "chat.cvOnePage.enabledBody",
  };
}
